import { getLenderById, LenderName } from '@nemuru-eng/js-api-client';
import { PricingFromCdn } from '@nemuru-eng/js-api-client/slim';
import { useEffect, useState } from 'react';

import { PricingFilterType } from '@/components/widgets/LoanDetailActions/components/LoanDetailActionsDialog/components/ChangeLoanConditionsDialog/types/PricingFilterType';

interface UseChangeLoanConditionsProps {
  pricings?: PricingFromCdn[];
}
export const useChangeLoanConditions = ({ pricings }: UseChangeLoanConditionsProps) => {
  const [filters, setFilters] = useState<PricingFilterType[]>([PricingFilterType.PROGRAM]);
  const [loading, setLoading] = useState(false);
  const [lenderNames, setLenderNames] = useState<{ lenderName: LenderName; id: string }[] | undefined>();

  const sortedPricings = pricings?.sort((a, b) => a.name.localeCompare(b.name));

  const pricingLendersIds = sortedPricings
    ? [
        ...new Set(
          sortedPricings.flatMap((pricing) =>
            pricing.ranges.flatMap((item) => (item.lenderIds ? item.lenderIds.map((lenderId) => lenderId) : [])),
          ),
        ),
      ]
    : [];

  useEffect(() => {
    if (!lenderNames && pricingLendersIds.length > 0) {
      setLoading(true);
      try {
        fetchLenderNames();
      } catch (error) {
      } finally {
        setLoading(false);
      }
    }
  }, [pricingLendersIds]);

  const fetchLenderNames = async () => {
    const lendersNames = await Promise.all(
      pricingLendersIds.map(async (lenderId) => {
        const lenderName = await getLenderById({ id: lenderId }).then((lender) => lender.name);
        return { lenderName, id: lenderId };
      }),
    );
    setLenderNames(lendersNames);
  };

  return { loading, filters, setFilters, lenderNames, sortedPricings };
};
